import { Box, ButtonBase, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";

export const Chip = styled(ButtonBase, {
  shouldForwardProp: (prop) => prop !== "toolbar",
})<{ toolbar?: boolean }>(({ theme, toolbar }) => {
  const isDark = theme.palette.mode === "dark";

  return {
    gap: theme.spacing(0.75),
    height: 36,
    padding: theme.spacing(0, 1.75),
    borderRadius: 999,
    backgroundColor: isDark ? theme.palette.grey[900] : theme.palette.grey[100],
    color: theme.palette.text.primary,
    whiteSpace: "nowrap",
    flexShrink: 0,
    fontFamily: theme.typography.fontFamily,

    "& svg": {
      fontSize: 16,
    },

    "&:hover": {
      backgroundColor: isDark
        ? theme.palette.grey[800]
        : theme.palette.grey[200],
    },

    ...(toolbar && {
      height: 32,
      padding: theme.spacing(0, 1.625),

      "& .StatusChip-icon": {
        fontSize: 18,
      },
    }),
  };
});

export const ChipLabel = styled("span")({
  fontSize: 13,
  fontWeight: 500,
  lineHeight: 1,
});

export const ChipValue = styled("span")(({ theme }) => ({
  fontSize: 13,
  fontWeight: 500,
  lineHeight: 1,
  color: theme.palette.text.secondary,
}));

export const Content = styled(Stack)(({ theme }) => ({
  width: 260,
  gap: theme.spacing(2),
  padding: theme.spacing(2),
}));

export const Section = styled(Stack)(({ theme }) => ({
  gap: theme.spacing(1),
}));

export const SectionTitle = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(0.5),
}));
